import type { CouponStats } from "@/store/types";

interface StatsGridProps {
  bundlesPurchased: number;
  stats: CouponStats;
}

function Stat({ value, label, accent }: { value: number; label: string; accent?: boolean }) {
  return (
    <div className="agd:flex-1 agd:basis-[100px] agd:shrink-0 agd:rounded-xl agd:bg-card agd:px-5 agd:py-3.5 agd:text-center agd:shadow-md agd:max-md:basis-auto agd:max-md:rounded-none agd:max-md:bg-transparent agd:max-md:px-1 agd:max-md:py-0 agd:max-md:shadow-none">
      <div
        className={
          "agd:text-[1.8rem] agd:font-bold agd:leading-none agd:max-md:text-[16px] " +
          (accent ? "agd:text-primary" : "agd:text-foreground")
        }
      >
        {value}
      </div>
      <div className="agd:mt-1.5 agd:text-[0.72rem] agd:uppercase agd:tracking-wide agd:text-muted-foreground agd:max-md:mt-1 agd:max-md:text-[8.5px] agd:max-md:leading-tight">
        {label}
      </div>
    </div>
  );
}

export default function StatsGrid({ bundlesPurchased, stats }: StatsGridProps) {
  return (
    <div className="agd:flex agd:flex-wrap agd:gap-4 agd:max-md:grid agd:max-md:grid-cols-4 agd:max-md:gap-0 agd:max-md:divide-x agd:max-md:divide-border agd:max-md:rounded-xl agd:max-md:bg-card agd:max-md:py-3 agd:max-md:shadow-md">
      <Stat value={bundlesPurchased} label="Bundles Purchased" accent />
      <Stat value={stats.total} label="Total Coupons" accent />
      <Stat value={stats.used} label="Used" />
      <Stat value={stats.remaining} label="Remaining" />
    </div>
  );
}
